/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FriendsParams,
  Friendship,
  FriendshipCreateInput,
  FriendshipsList,
  RelationshipPendingCount,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Friends
 */
export const friends = (
    params?: MaybeRefOrGetter<FriendsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FriendshipsList>(
      {url: `/friends`, method: 'GET',
        params, signal
    },
      );
    }




export const getFriendsQueryKey = (params?: MaybeRefOrGetter<FriendsParams>,) => {
    return [
    'friends', ...(params ? [params] : [])
    ] as const;
    }


export const getFriendsQueryOptions = <TData = Awaited<ReturnType<typeof friends>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FriendsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friends>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFriendsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof friends>>> = ({ signal }) => friends(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof friends>>, TError, TData>
}

export type FriendsQueryResult = NonNullable<Awaited<ReturnType<typeof friends>>>
export type FriendsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Friends
 */

export function useFriends<TData = Awaited<ReturnType<typeof friends>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FriendsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friends>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFriendsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Send Friend Request
 */
export const createFriendship = (
    friendshipCreateInput: MaybeRefOrGetter<FriendshipCreateInput>,
 signal?: AbortSignal
) => {
      friendshipCreateInput = toValue(friendshipCreateInput);

      return axiosClient<Friendship>(
      {url: `/friends`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: friendshipCreateInput, signal
    },
      );
    }




export const getCreateFriendshipMutationKey = () => ['createFriendship'] as const;

export const getCreateFriendshipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFriendship>>, TError,CreateFriendshipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFriendship>>, TError,CreateFriendshipMutationVariables, TContext> => {

const mutationKey = getCreateFriendshipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFriendship>>, CreateFriendshipMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFriendship(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFriendshipMutationResult = NonNullable<Awaited<ReturnType<typeof createFriendship>>>
    export type CreateFriendshipMutationBody = FriendshipCreateInput
    export type CreateFriendshipMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFriendshipMutationVariables = {data: FriendshipCreateInput}

    /**
 * @summary Send Friend Request
 */
export const useCreateFriendship = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFriendship>>, TError,CreateFriendshipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFriendship>>,
        TError,
        CreateFriendshipMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFriendshipMutationOptions(options), queryClient);
    }
    /**
 * @summary Pending friend request count
 */
export const friendsPendingCount = (

 signal?: AbortSignal
) => {


      return axiosClient<RelationshipPendingCount>(
      {url: `/friends/pending-count`, method: 'GET', signal
    },
      );
    }




export const getFriendsPendingCountQueryKey = () => {
    return [
    'friends','pending-count'
    ] as const;
    }


export const getFriendsPendingCountQueryOptions = <TData = Awaited<ReturnType<typeof friendsPendingCount>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friendsPendingCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFriendsPendingCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof friendsPendingCount>>> = ({ signal }) => friendsPendingCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof friendsPendingCount>>, TError, TData>
}

export type FriendsPendingCountQueryResult = NonNullable<Awaited<ReturnType<typeof friendsPendingCount>>>
export type FriendsPendingCountQueryError = ErrorType<StandardError>


/**
 * @summary Pending friend request count
 */

export function useFriendsPendingCount<TData = Awaited<ReturnType<typeof friendsPendingCount>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friendsPendingCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFriendsPendingCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Friendship
 */
export const friendship = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<Friendship>(
      {url: `/friends/${username}`, method: 'GET', signal
    },
      );
    }




export const getFriendshipQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'friends',username
    ] as const;
    }


export const getFriendshipQueryOptions = <TData = Awaited<ReturnType<typeof friendship>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friendship>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFriendshipQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof friendship>>> = ({ signal }) => friendship(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof friendship>>, TError, TData>
}

export type FriendshipQueryResult = NonNullable<Awaited<ReturnType<typeof friendship>>>
export type FriendshipQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Friendship
 */

export function useFriendship<TData = Awaited<ReturnType<typeof friendship>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof friendship>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFriendshipQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Withdraw a request, or end a friendship
 */
export const destroyFriendship = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<void>(
      {url: `/friends/${username}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFriendshipMutationKey = () => ['destroyFriendship'] as const;

export const getDestroyFriendshipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFriendship>>, TError,DestroyFriendshipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFriendship>>, TError,DestroyFriendshipMutationVariables, TContext> => {

const mutationKey = getDestroyFriendshipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFriendship>>, DestroyFriendshipMutationVariables> = (props) => {
          const {username} = props ?? {};

          return  destroyFriendship(username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFriendshipMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFriendship>>>

    export type DestroyFriendshipMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyFriendshipMutationVariables = {username: string}

    /**
 * @summary Withdraw a request, or end a friendship
 */
export const useDestroyFriendship = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFriendship>>, TError,DestroyFriendshipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFriendship>>,
        TError,
        DestroyFriendshipMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFriendshipMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Friend Request
 */
export const acceptFriendship = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<Friendship>(
      {url: `/friends/${username}/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFriendshipMutationKey = () => ['acceptFriendship'] as const;

export const getAcceptFriendshipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFriendship>>, TError,AcceptFriendshipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFriendship>>, TError,AcceptFriendshipMutationVariables, TContext> => {

const mutationKey = getAcceptFriendshipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFriendship>>, AcceptFriendshipMutationVariables> = (props) => {
          const {username} = props ?? {};

          return  acceptFriendship(username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFriendshipMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFriendship>>>

    export type AcceptFriendshipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type AcceptFriendshipMutationVariables = {username: string}

    /**
 * @summary Accept Friend Request
 */
export const useAcceptFriendship = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFriendship>>, TError,AcceptFriendshipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFriendship>>,
        TError,
        AcceptFriendshipMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptFriendshipMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Friend Request
 */
export const declineFriendship = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<Friendship>(
      {url: `/friends/${username}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFriendshipMutationKey = () => ['declineFriendship'] as const;

export const getDeclineFriendshipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFriendship>>, TError,DeclineFriendshipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFriendship>>, TError,DeclineFriendshipMutationVariables, TContext> => {

const mutationKey = getDeclineFriendshipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFriendship>>, DeclineFriendshipMutationVariables> = (props) => {
          const {username} = props ?? {};

          return  declineFriendship(username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFriendshipMutationResult = NonNullable<Awaited<ReturnType<typeof declineFriendship>>>

    export type DeclineFriendshipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DeclineFriendshipMutationVariables = {username: string}

    /**
 * @summary Decline Friend Request
 */
export const useDeclineFriendship = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFriendship>>, TError,DeclineFriendshipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFriendship>>,
        TError,
        DeclineFriendshipMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineFriendshipMutationOptions(options), queryClient);
    }
    /**
 * @summary Ignore Friend Request
 */
export const ignoreFriendship = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<Friendship>(
      {url: `/friends/${username}/ignore`, method: 'PUT', signal
    },
      );
    }




export const getIgnoreFriendshipMutationKey = () => ['ignoreFriendship'] as const;

export const getIgnoreFriendshipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreFriendship>>, TError,IgnoreFriendshipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof ignoreFriendship>>, TError,IgnoreFriendshipMutationVariables, TContext> => {

const mutationKey = getIgnoreFriendshipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ignoreFriendship>>, IgnoreFriendshipMutationVariables> = (props) => {
          const {username} = props ?? {};

          return  ignoreFriendship(username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IgnoreFriendshipMutationResult = NonNullable<Awaited<ReturnType<typeof ignoreFriendship>>>

    export type IgnoreFriendshipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type IgnoreFriendshipMutationVariables = {username: string}

    /**
 * @summary Ignore Friend Request
 */
export const useIgnoreFriendship = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ignoreFriendship>>, TError,IgnoreFriendshipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof ignoreFriendship>>,
        TError,
        IgnoreFriendshipMutationVariables,
        TContext
      > => {
      return useMutation(getIgnoreFriendshipMutationOptions(options), queryClient);
    }
